function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#2E8EC0",
  width: "14",
  height: "14",
  rx: "1.556"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.42 8.092c1.145-.041 2.1.888 2.173 2.25a.35.35 0 01-.699.037c-.053-.99-.695-1.615-1.449-1.587-.308.01-.549.112-.632.223l-.014.021a.35.35 0 01-.61-.343c.206-.366.683-.581 1.231-.6zM3.665 8.092c-1.145-.041-2.1.888-2.174 2.25a.35.35 0 00.7.037c.053-.99.695-1.615 1.448-1.587.309.01.55.112.633.223l.014.021a.35.35 0 00.61-.343c-.207-.366-.683-.581-1.231-.6z",
  fill: "#96C6DF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.962 6.225a1.829 1.829 0 100-3.658 1.829 1.829 0 000 3.658zm0-2.918a1.089 1.089 0 110 2.178 1.089 1.089 0 010-2.178zM7.066 6.926c-1.706 0-3.09 1.502-3.09 3.342 0 .199.164.359.364.359.2 0 .364-.16.364-.359 0-1.45 1.062-2.624 2.362-2.624s2.362 1.175 2.362 2.624c0 .199.164.359.364.359.2 0 .363-.16.363-.359 0-1.84-1.383-3.342-3.089-3.342z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.549 7.322a1.407 1.407 0 100-2.813 1.407 1.407 0 000 2.813zm0-2.073a.666.666 0 110 1.333.666.666 0 010-1.333zM10.459 7.322a1.407 1.407 0 100-2.813 1.407 1.407 0 000 2.813zm0-2.073a.666.666 0 110 1.333.666.666 0 010-1.333z",
  fill: "#96C6DF"
}))));